/* eslint-disable complexity */
/* eslint-disable jsx-a11y/anchor-is-valid */
/**
 * @file   建筑详情
 * @create macaiqi 2021/11/25
 * @update
 */
import React, { useEffect, useState } from 'react';
import Bread from '../../common/Bread'
import { queryInstanceDetails, queryInstanceRel, queryNodeLabel, queryInstanceDetailsV2 } from '../../../shared/api';
import InnerTitle from '../../common/InnerTitle';
import { htmltoStr } from '@/utils';
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import cls from 'classnames';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from 'jquery';
import Star from '../../common/Star'
import './index.scss';
import './circle.css';
import './iconfont.css';
import './instanceDetails.css';
import dImg from '../../../../assets/images/desktop/common/defaultImg.jpg';
import markImg from '../../../../assets/images/desktop/common/markImg.png';
import Loading from '../../../components/Loading';
import { MapDetail } from './MapDetail';
// import DoStar from '../PersonalPage/dostar';
import InstanceBox from '../../common/InstanceBox';

const pre = window.ENV_IMG_PREURL_SRC;

// 轮播图
const Slide = ({ picList, id }) => {
  const arr = picList?.filter(item => {
    return item?.fileCategory === 'FILE_TYPE_PICTURE';
  })
  const handleAfterChange = () => {
    const activeDom = [...document.getElementsByClassName('js-slider-main')[0].childNodes].find(item => item.className.includes('slick-active'))
    activeDom.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })
  }
  const settings = {
    customPaging: function (i) {
      return (
        <img
          src={arr[i].fileThumbnail ? `${pre}/${arr[i].fileThumbnail}` : dImg}
          alt="图片"
        />
      )
    },
    dots: true,
    dotsClass: "m-slider-dot-ul js-slider-main",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    className: "m-slider",
    afterChange: handleAfterChange
  };
  return (
    <div className="slide">
      <Slider {...settings}>
        {arr && arr.map(item => {
          return (
            <div className="pic-item" key={item.id}>
              {/* <Link to={`/PicturelistPage/${item?.fileId}`}> */}
              <Link to={`/PicturelistPage/${id}?fileInfoId=${item?.fileInfoId}&hasMark=${item?.markSum ? '1' : '0'}`} className={cls({'mark':item.markSum})} target="_blank">
                <img className="m-shop-preview-slider-main-img" src={item?.fileThumbnail ? `${pre}/${item?.fileThumbnail}` : dImg} alt='' />
                {item.markSum ? <img className='markImg' src={markImg}/> : ''}
              </Link>
            </div>
          )
        })}
      </Slider>
      {arr?.length === 0 && (
        <div className="pic-item">
          <img className="m-shop-preview-slider-main-img" src={dImg} alt='' />
        </div>
      )}
    </div>
  )
}

// 关联资源
const Relate = ({ data }) => {
  const settings1 = {
    className: "center",
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 5,
    swipeToSlide: true,
    // afterChange: function (index) {
    //   console.log(
    //     `Slider Changed to: ${index + 1}, background: #222; color: #bada55`
    //   );
    // }
  };
  return (
    <div className="relate">
      {data?.datas?.records?.length > 5 ? <Slider {...settings1} className="relate-slide">
        {data?.datas?.records?.map(item => {
          return (
            <a className="relate-item" href={item.sourceLink} rel="noopener noreferrer" target="_blank" key={item.id}>
              <div className="imgbox">
                <img src={`${pre}/${item.fileThumbnail}`} alt="" />
              </div>
              <p>{htmltoStr(item.fileName)}</p>
            </a>
          )
        })}
      </Slider> : <div className="relate-slidebox">
        {data?.datas?.records?.map(item => {
          return (
            <a className="relate-item" href={item.sourceLink} rel="noopener noreferrer" target="_blank" key={item.id}>
              <div className="imgbox">
                <img src={`${pre}/${item.fileThumbnail}`} alt="" />
              </div>
              <p>{htmltoStr(item.fileName)}</p>
            </a>
          )
        })}
      </div>}

    </div>
  )
}

// 历史沿革
const History = ({ data,setInstanceStr,setTime }) => {
  const [showAll, setShowAll] = useState(true);
  const [active, setActive] = useState(true);
  const ulHeight = $('.historyul').height();
 useEffect(() => {
  const len = $('.historyul a').length;
  if(len > 0){
    $('.historyul a').click((e)=>{
      viewInstanceBox(e,setInstanceStr,setTime);
    })
  }
 },[]);
  useEffect(() => {
    if(ulHeight > 250) {
      setShowAll(false)
      setActive(false)
    } else {
      setShowAll(true)
      setActive(true)
    }
  }, [ulHeight])
  return (
    <div className={cls("history", {showall: showAll || active})}>
      <div>
      <ul className="historyul">
        {data?.datas?.records?.map(item => {
          return (
            <li key={item.id}>
              <span className="year" dangerouslySetInnerHTML={{
                __html: `${item?.properties?.dateNote ? item?.properties?.dateNote + ',' : ''}`
              }} />
              <span dangerouslySetInnerHTML={{
                __html: item?.properties?.description
              }} />
            </li>
          )
        })}
      </ul>
      </div>
      {!showAll &&
        <p className={cls("more", {showall: active})} onClick={() => {setActive(!active)}}>
          <i className="iconfont icon-jiantouxia" />
          <span>{!active ? '查看更多' : '收起'}</span>
        </p>}
    </div>
  )
}

// 操作
const Operate = ({ data,setInstanceStr,setTime }) => {
  useEffect(() => {
   const len = $('.operate a').length;
   if(len > 0){
     $('.operate a').click((e)=>{
      viewInstanceBox(e,setInstanceStr,setTime);
     })
   }
  },[]);
  return (
    <div className="operate">
      {data.moduleName === '作者简介' ? (
        <div dangerouslySetInnerHTML={{
          __html: data?.datas[0]?.properties?.description
        }} />
      ) : (
        <div dangerouslySetInnerHTML={{
          __html: data?.datas
        }} />
      )}
    </div>
  )
}
// 题跋、款识、印鉴
const Titlelist = ({ data,setInstanceStr,setTime }) => {
  const arr = Object.keys(data?.datas);
  const d = data.datas;
  useEffect(() => {
   const len = $('.titlelist a').length;
   if(len > 0){
     $('.titlelist a').click((e)=>{
      viewInstanceBox(e,setInstanceStr,setTime);
     })
   }
  },[]);
  return (
    <div className="titlelist">
      <ul>
        {arr.map((item, index) => {
          return (<li key={index}>
            <div className="tl">
              【{item}】
            </div>
            <div className="tr">
              {d && d[item]?.records?.map(i => {
                return <p key={i.id} dangerouslySetInnerHTML={{
                  __html: i?.properties?.prefaceAndPostscriptText || i?.properties?.sealImpressionText
                }} />
              })}
            </div>
          </li>)
        })}
      </ul>
    </div>
  )
}
// 建筑布局
const Map = ({ data,setInstanceStr,setTime }) => {
  useEffect(() => {
   const len = $('.historyb a').length;
   if(len > 0){
     $('.historyb a').click((e)=>{
      viewInstanceBox(e,setInstanceStr,setTime);
     })
   }
  },[]);
  return (
    <div className="historyb">
      <div className="history-desc" dangerouslySetInnerHTML={{
        __html: data?.datas?.arrangement
      }} />
      <div className="history-map">
        <MapDetail data={data?.datas?.geo} />
      </div>
    </div>
  )
}

// 文物遗存
const Culture = ({ data }) => {
  const settings = {
    className: "slider variable-width",
    dots: false,
    infinite: false,
    centerMode: false,
    // slidesToShow: 1,
    // slidesToScroll: 1,
    variableWidth: true,
    swipeToSlide: true,
  };
  const isRelic = data?.moduleCode === "relics";
  return (
    <div className="culture">
      <Slider {...settings}>
        {data?.datas?.map((item, index) => {
          return (
            <div className="culture-item" key={index}>
              <div className="imgbox">
                {isRelic ? (
                  <Link to={`/Subject/HistoricalBuilding/${item?.instanceId}`} target="_blank">
                    <div className="mask">
                      {htmltoStr(item?.instanceName)}
                    </div>
                    <img src={item?.showImage ? `${pre}/${item?.showImage}` : dImg} alt="" />
                    <p className='relics-name ellipsis'>{htmltoStr(item?.instanceName)}</p>
                  </Link>
                ) : (
                  <>
                  <div className="mask">
                    {item?.instanceModel?.instanceName}
                  </div>
                  <img src={item?.showImage ? `${pre}/${item?.showImage}` : dImg} alt="" />
                  </>
                )}
              </div>
            </div>
          )
        })}
      </Slider>
    </div>
  )
}

// 相关推荐
const Recommend = ({ data }) => {
  // const [list, setList] = useState();
  // useEffect(() => {
  //   queryInstanceRel({
  //     current: 1,
  //     size: 8,
  //     conceptCodes: [],
  //     nodeId: id,
  //     relationshipType: "Concept",
  //   }).then(res => {
  //     if (res) {
  //       setList(res)
  //     }
  //   })
  // }, [id])
  return (
    <div className="recommend">
      <ul>
        {data?.datas?.slice(0, 8)?.map((item, index) => {
          return (
            <li key={index}>
              <Link to={`/Subject/HistoricalBuilding/${item?.instanceId}`} target="_blank">
                <div className={`avatar ${item?.conceptCode}`}>
                  {item?.properties?.showImage && <img src={`${pre}/${item?.properties?.showImage}`} alt="" />}
                </div>
                <p>{htmltoStr(item?.instanceName)}</p>
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

// 关联建筑
// eslint-disable-next-line no-unused-vars
const ImgText = ({data}) => {
  return (
    <div className="img-text">
      <ul>
        {data?.datas?.map((item, index) => {
          const imgSrc = item.showImage ? `${pre}/${item?.showImage}` : dImg;
          return (
            <li key={index}>
              <Link to={`/Subject/HistoricalBuilding/${item?.instanceId}`}>
                <div className="l-img">
                  <img src={imgSrc} alt="" />
                </div>
                <div className="r-text">
                  {htmltoStr(item?.properties?.description)}
                </div>
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

// 关系图谱
const Relation = ({ id, detail }) => {
  console.log('关系图谱')
  const [data, setData] = useState();
  const [init, setInit] = useState(true);
  useEffect(() => {
    if(id){
      queryNodeLabel({
        instanceId: id
      }).then(res => {
        if (res) {
          setData(res);
        }
      });
    }
  }, [id]);
  // 拼接关系图谱卡片数据HTML
  function queryNodeByCardHtml(code, datas) {
    $('.rightCardContent').empty();
    let html = '<ul class="clearfix">'
    for (let i = 0; i < datas.length; i++) {
      html += '<li style="animation-delay: 0.3' + i + 's;">'
      html += '<div class="avator-container" data-name="' + datas[i]?.instanceModel?.instanceName +
        '" onClick="handleBigMapClick(this)">'
      html += '<div class="outer"></div>'
      html += '<div class="inner"></div>'
      html += `<a href="/Relation/${datas[i]?.instanceModel?.instanceId}" target="_blank"><div class="avatar">`
      html += '<span class="icon">'
      html += '<i class="huitufont ' + code + '"></i>'
      html += '</span>'
      html += '</div>'
      if (datas[i].direction === 1) {
        html += '<div class="relation-name">'
        html += '<span class="relation-arrow" data-dir="->"></span>'
      } else {
        html += '<div class="relation-name relation-name-left">'
        html += '<span class="relation-arrow left-arrow" data-dir="<-"></span>'
      }
      html += '<span class="relation-detail">' + datas[i]?.rel?.properties?.relationshipName + '</span>'
      html += '</div>'
      html += '<div class="entry-name">' + (datas[i]?.instanceModel?.instanceName || ' ') + '</div></a>'
      html += '</li>'
    }
    html += '</ul>'
    $('.rightCardContent').append(html);

    $('.rightCardContent li').mouseenter(function () {
      $(this).find('.avator-container').addClass('liHover1');
    });
    $('.rightCardContent li').mouseleave(function () {
      $(this).find('.avator-container').removeClass('liHover1');
    });
  }
  function queryNodeByName(code) {
    queryInstanceRel({
      current: 1,
      size: 4,
      conceptCodes: [code],
      nodeId: id,
      relationshipType: 'Concept',
    }).then(res => {
      if (res) {
        queryNodeByCardHtml(code, res)
      }
    })
  };
  function circularLoadFunction() {
    // let i = 2;
    let radius = 200;
    let fields = $('.itemDot');
    let container = $('.dotCircle');
    let width = container.width();
    radius = width / 2.5;
    let height = container.height();
    let angle = 0;
    let step = (2 * Math.PI) / fields.length;
    fields.each(function () {
      let x = Math.round(width / 2 + radius * Math.cos(angle) - $(this).width() / 2);
      let y = Math.round(height / 2 + radius * Math.sin(angle) - $(this).height() / 2);
      $(this).css({
        left: x + 'px',
        top: y + 'px'
      });
      angle += step;
    });
    $('.itemDot').click(function () {
      let dataTab = $(this).data("tab");
      let dataCode = $(this).data("code");
      $('.itemDot').removeClass('active');
      $(this).addClass('active');
      $('.CirItem').removeClass('active');
      $('.CirItem' + dataTab).addClass('active');
      // i = dataTab;
      // $('.dotCircle').css({
      //   "transform": "rotate(" + (360 - (i - 1) * 36) + "deg)",
      //   "transition": "2s"
      // });
      // $('.itemDot').css({
      //   "transform": "rotate(" + ((i - 1) * 36) + "deg)",
      //   "transition": "1s"
      // });
      queryNodeByName(dataCode);
    });
  }
  function relationshipGraphHtml(datas) {
    if(!init){
      return;
    }
    setInit(false);
    $('.holderCircle').empty();
    let html = '<div class="dotCircle">'
    for (let i = 0; i < datas.length; i++) {
      if (i === 0) {
        html += '<div class="itemDot itemDot' + (i + 1) + ' active" data-tab="' + (i + 1) + '"  data-code="' + datas[i].labelCode +
          '">'
        queryNodeByName(datas[0].labelCode);
      } else {
        html += '<div class="itemDot itemDot' + (i + 1) + '" data-tab="' + (i + 1) + '"  data-code="' + datas[i].labelCode + '">'
      }
      html += '<span class="text">' + datas[i].labelName + '</span>'
      html += '<i class="huitufont ' + datas[i].labelCode + '"></i>'
      html += '<span class="forActive"></span>'
      html += '</div>'
    }
    html += '</div>'
    if (detail?.showImage) {
      html += '<div class="contentCircle" style="background:url(' + pre + '/' + detail?.showImage +
        ') no-repeat center/cover;background-size: 100% auto;">'
    } else {
      html += '<div class="contentCircle">'
      html += `<img class="defaultCircle" src=${dImg}>`
    }
    html += '<span class="userName">' + (detail?.instanceName || ' ') + '</span>'
    html += '</div>'
    $('.holderCircle').append(html);
    circularLoadFunction();
  }
  data && relationshipGraphHtml(data)
  return (
    <div className="relation-cont">
      <div className="bottomContent bottomContentKgsMap">
        <div className="holderCircle" />
        <div className="rightCardContent" />
      </div>
    </div>
  )
}

// 基本信息
const Basic = ({ data,files, id,setInstanceStr,setTime }) => {
  const d = data?.datas;
  useEffect(() => {
    // 给属性字段中的高亮实例名称绑定点击事件
    instanceNameClickBind();
    // 给描述信息中的高亮实例名称绑定点击事件
    const len1 = $('.bottom .desc a').length;
    if(len1 > 0){
     $('.bottom .desc a').click((e)=>{
       viewInstanceBox(e,setInstanceStr,setTime);
     })
    }
  },[]);

  // 给高亮实例名称绑定点击事件
  const instanceNameClickBind = () => {
    const len = $('.baseInfor a').length;
    if(len > 0){
      $('.baseInfor a').click((e)=>{
        viewInstanceBox(e,setInstanceStr,setTime);
      })
    }
  }

  // 判断是否存在html标签不完整的情况,若存在截取最后一个标签之前的字符并拼接上...
  const transformStr = (str) => {
    let res = str.match(/</g);
    if(res && res.length % 2 == 0){
      return str+'...';
    }else{
      let lastIndex = str.lastIndexOf('<');
      return lastIndex > -1 ? str.substring(0,lastIndex)+'...' : str+'...';
    }
  }
  return (
    <>
      <div className="l">
        <ul className="baseInfor">
          {data?.attrs.map((item, index) => {
            let name;
            d?.attrTriples.forEach(i => {
              if (i.englishCode === item) {
                name = i.relationshipName;
              }
            })
            let showAllDetail = false;
            const val = d?.properties[item];
            let val1;
            let overflow = false;
            if(name && val && val !== 'none' && val.length>150){
              val1 = val.substring(0,150);
              // 判断是否存在html标签不完整的情况
              val1 = transformStr(val1);
              overflow = true;
            }else{
              val1 = val;
            }
            const showname = htmltoStr(name);
            return (
              name && val && val !== 'none' && <li className={cls({length: data?.specialAttrs?.includes(item)})} key={index}>
                <span className="key">{showname}</span>
                <span className="value">
                  <div className='content' id={'attrId'+index} dangerouslySetInnerHTML={{
                      __html: val1
                    }} />
                  {
                    overflow && <div className='toggleBtn' id={'toggleBtn'+index} onClick={()=>{
                      showAllDetail = !showAllDetail;
                      $('#attrId'+index)[0].innerHTML = showAllDetail ? val : val1;
                      $('#toggleBtn'+index)[0].innerHTML = showAllDetail ? '【收起】' : '【展开】';
                      // 给属性字段中的高亮实例名称绑定点击事件
                      instanceNameClickBind();
                    }}>【展开】</div>
                  }
                </span>
              </li>
            )
          })}
        </ul>
      </div>
      {d?.files && <div className="r"><Slide picList={files} id={id} /></div>}
      <div className="bottom">
        <div className="desc" dangerouslySetInnerHTML={{
          __html: d?.properties?.description
        }} />
        <Star operationType = '1' instanceId={d?.instanceId} />
        <div className="flexbox">
          {d?.tagTriples && <ul className="tag">
            {d?.tagTriples.map(item => {
              return (<li key={item.tagId}>
                {/* <div dangerouslySetInnerHTML={{
                  __html: item.tagName
                }} /> */}
                <a href={`/KnowledgeSearch?key=${htmltoStr(item.tagName)}`} target="_blank" rel="noreferrer">
                {htmltoStr(item.tagName)}
                </a>
              </li>)
            })}
          </ul>}
        </div>
      </div>
    </>
  )
}

// 点击高亮链接，打开实例详情弹框
const viewInstanceBox = (e,setInstanceStr,setTime) => {
  e.preventDefault();
  const href = e.target.href.split('/');
  const str = href[href.length-2]+','+e.target.innerText;
  setInstanceStr(str);
  setTime(new Date().getTime());
}
// 详情
const ArchitecturalDetails = (props) => {
  const [data, setData] = useState({});
  const [detail, setDetail] = useState();
  const [anchor, setAnchor] = useState();
  const [i, setI] = useState();
  const [loading, setLoading] = useState(true);
  const { id } = props.match.params;
  const [instanceStr, setInstanceStr] = useState(); 
  const [time,setTime] = useState();
  useEffect(() => {
    queryInstanceDetails({
      instanceId: id
    }).then(res => {
      if (res) {
        setDetail(res);
      }
    });
    queryInstanceDetailsV2({
      instanceId: id
    }).then(res => {
      setLoading(false);
      if (res) {
        setData(res);
        setAnchor(res?.modules[0]?.moduleCode);
        setI(res?.modules[0]?.datas?.instanceId);
      }
    });
  }, [id])
  useEffect(() => {
    window.onscroll = function () {
      // 获取当前页面的滚动条纵坐标位置 （依次为火狐谷歌、safari、IE678）
      let scrollT =
        document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      data?.modules?.forEach(item => {
        if(!document.getElementById(item.moduleCode)) {
          return
        }
        let itemoffset = document.getElementById(item.moduleCode).offsetTop;
        if(scrollT > itemoffset - 350 && scrollT < itemoffset + 50) {
         $(`#li-${item.moduleCode} .a`).addClass('active');
         $(`#li-${item.moduleCode}`).siblings().children('.a').removeClass('active');
        }
      })
    }
  }, [data?.modules])
  const path = data?.code === 'Person' ? `/Subject/Person` : `/Subject/${data?.code}?conceptCode=${detail?.conceptCode}`;
  return (<div className="architecturaldetails">
    {data && data?.modules && <div className="llist">
      <ul>
        <li className="before"><span /></li>
        {data?.modules?.map((item, index) => {
          if (!item?.datas || (item?.datas?.records?.length === 0) || (item?.datas?.length === 0 && item.moduleName !== '关系图谱') || (item.moduleName === '关系图谱' && item.datas !== 1) || (JSON.stringify(item.datas) === '{}') || item.moduleCode === 'img_text_list') { return null }
          return (
            <li
              key={index} id={`li-${item.moduleCode}`}
              onClick={() => {
                $('body,html').animate({ scrollTop: document.getElementById(item.moduleCode).offsetTop - 100 }, 300);
             }}
            >
              {/* <a href={`#${item?.moduleCode}`} className={cls({ active: item?.moduleCode === anchor })}> */}
              <div className={cls('a', {active: item?.moduleCode === anchor })}>
              <span /><p>{htmltoStr(item?.moduleName)}</p>
              </div>
            </li>
          )
        })}
        <li className="after"><span /></li>
      </ul>
    </div>}
    {data && <Bread title={data?.conceptName} path={path} />}
    <div className="allcenter">
      {loading ? (
        <Loading />
      ) : (
        <>
        <h2 className="detail-title">{detail?.instanceName}</h2>
        <div className="detail_content">
          {
            data?.modules?.map((item, index) => {
              if (!item?.datas || (item?.datas?.records?.length === 0) || (item?.datas?.length === 0 && item.moduleName !== '关系图谱') || (item.moduleName === '关系图谱' && item.datas !== 1) || (JSON.stringify(item.datas) === '{}') || item.moduleCode === 'img_text_list') { return null }
              return (
                <div className="column" id={item.moduleCode} key={index} >
                  <div name={item.moduleCode} className='column-anchor'>
                    <InnerTitle name={item.moduleName} id={item.moduleCode === 'relation_graph' ? i : ''} />
                    {
                      item.moduleCode === 'basic_info' && <div className="column-cont baseInfor-cont">
                        <Basic data={item} files={detail?.files} id={i}  setInstanceStr={setInstanceStr} setTime={setTime}/>
                      </div>
                    }
                    {
                      item.moduleCode === 'resource' && <div className="column-cont relate-cont">
                        <Relate data={item} />
                      </div>
                    }
                    {
                      item.moduleCode === 'text_list' && <div className="column-cont">
                        <History data={item} setInstanceStr={setInstanceStr} setTime={setTime}/>
                      </div>
                    }
                    {
                      item.moduleCode === 'paragraph' && <div className="column-cont">
                        <Operate data={item}  setInstanceStr={setInstanceStr} setTime={setTime}/>
                      </div>
                    }
                    {
                      item.moduleCode === 'text' && <div className="column-cont">
                        <Operate data={item}  setInstanceStr={setInstanceStr} setTime={setTime}/>
                      </div>
                    }
                    {
                      item.moduleCode === 'postscript' && <div className="column-cont">
                        <Titlelist data={item} setInstanceStr={setInstanceStr} setTime={setTime}/>
                      </div>
                    }
                    {
                      item.moduleCode === 'composition' && <div className="column-cont">
                        <Map data={item} setInstanceStr={setInstanceStr} setTime={setTime}/>
                      </div>
                    }
                    {
                      item.moduleCode === 'relics' && <div className="column-cont">
                        <Culture data={item} />
                      </div>
                    }
                    {
                      item.moduleCode === 'relation_graph' && <div className="column-cont">
                        <Relation id={i} detail={detail} />
                      </div>
                    }
                    {
                      item.moduleCode === 'recommend' && <div className="column-cont">
                        <Recommend data={item} />
                      </div>
                    }
                    {/* {
                      item.moduleCode === 'img_text_list' && <div className="column-cont">
                        <ImgText data={item} />
                      </div>
                    } */}
                  </div>
                </div>
              )
            })
          }
        </div>
        </>
      )}
    </div>
    <InstanceBox instanceStr={instanceStr} time={time}/> 
  </div>)
};

export default ArchitecturalDetails;
